module.exports = __webpack_public_path__ + "images/fa-mwe-banner-side-mobile.webp";